import staticData from "@/public/data/flight/results.json";
import Flex from "@/shared/components/common/Flex";
import type { Flight } from "@/types/services/flight/apis/Availability";
import type { Route } from ".";
import PhosphorIcon from "@/shared/components/common/PhosphorIcon";
import Typography from "@/shared/components/common/Typography";
import { format } from "date-fns-jalali";

interface RoundtripCardItemProps {
  flight: Flight;
  route: Route;
  changeDeparture: () => void;
}

export default function RoundtripCardItem({
  flight,
  route,
  changeDeparture,
}: RoundtripCardItemProps) {
  const { changeTicketLabel } = staticData.roundTrip;
  const { departure_time, departure_city_name_lang, date } = flight;
  const { origin, destination } = route;
  return (
    <Flex
      alignItems={"center"}
      justifyContent={"between"}
      className="w-full p-2 md:p-3 bg-background rounded-sm ring-1 ring-border md:ring-0 cursor-pointer hover:bg-muted dark:hover:bg-muted/10 transition duration-100 ease-in-out group"
    >
      <Flex alignItems={"center"} gap={"3"}>
        <Flex.Item className="p-2 bg-primary rounded-sm">
          <PhosphorIcon
            name="AirplaneTakeoff"
            size={26}
            className="!transform !scale-x-[-1] text-background"
          />
        </Flex.Item>

        <Flex direction={"col"}>
          <Flex.Item>
            <Flex alignItems={"center"} gap={"2"}>
              <Flex.Item>
                {date && (
                  <Typography variant={"caption"} fontWeight={"normal"}>
                    {format(date, "EEE, dd MMMM yyyy")}
                  </Typography>
                )}
              </Flex.Item>
            </Flex>
          </Flex.Item>
          <Flex.Item>
            <Flex alignItems={"center"} gap={"2"}>
              <Flex.Item>
                <Typography variant={"body3"} fontWeight={"medium"}>
                  {origin}
                </Typography>
              </Flex.Item>
              <PhosphorIcon
                name="ArrowLeft"
                size={12}
                className="text-grayColor-foreground"
              />
              <Flex.Item>
                <Typography variant={"body3"} fontWeight={"medium"}>
                  {destination}
                </Typography>
              </Flex.Item>
            </Flex>
          </Flex.Item>
        </Flex>
      </Flex>

      <Flex
        alignItems={"center"}
        gap={"1"}
        className="p-1 rounded-full bg-primary scale-0 group-hover:scale-100 transition-scale duration-75 ease-in-out"
        onClick={changeDeparture}
      >
        {/* <Typography variant={"caption"}>{changeTicketLabel}</Typography> */}

        <PhosphorIcon name="X" size={14} className="text-background" />
      </Flex>
    </Flex>
  );
}
